import createHTMLElement from '../services/create-element.js';

const TEST_PAGES = [1198365, 497458, 163723];

const addScript = () => {
  const src = window.Site.human.src;

  if (!src) {
    return;
  }

  const script = createHTMLElement(`script`, {
    src,
    async: true,
    'data-pgi-dis-hold': `hmnsPgiEvent`,
  });

  document.head.appendChild(script);
};

const creatGlobalObject = () => {
  const regExp = window.Site.human.regExp;

  if (!regExp) {
    return;
  }

  window.hmnsPgiEvent = {
    dispatch: (arg) => {
      const hmnsRegex = new RegExp(regExp);
      const hmnsIvtDec = !hmnsRegex.test(arg.value);

      // Logic to handle IVT (not valid)
      if (hmnsIvtDec) {
      }
      // Logic to handle not-IVT (valid)
      else {
      }
    },
  };
};

export const initHuman = () => {
  const isEnabled = window.Site.human;
  const entityId = window.Site.entity_id;

  if (!isEnabled || !entityId) {
    return;
  }

  const isTestPage = TEST_PAGES.some((pageId) => pageId === entityId);

  if (isTestPage) {
    creatGlobalObject();
    addScript();
  }
};
